var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrangePolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 430,
    viewBox: "0 0 479 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330.778 0.363324C351.107 0.371754 369.888 11.2251 380.045 28.8351L471.011 186.542C481.168 204.152 481.159 225.844 470.987 243.445L379.891 401.077C369.719 418.679 350.929 429.516 330.6 429.508L148.539 429.432C128.209 429.424 109.429 418.571 99.2714 400.961L8.30622 243.253C-1.85116 225.643 -1.84219 203.952 8.32982 186.351L99.4258 28.7187C109.598 11.1172 128.387 0.279366 148.717 0.287802L330.778 0.363324Z",
    fill: "#EEB544"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePolygon);
export default __webpack_public_path__ + "static/media/orange-polygon.d1e7542e6e41a609a3dc1aabcc1a9adb.svg";
export { ForwardRef as ReactComponent };